








































































































































































































import CircularLoader from "@/components/svg/CircularLoader.vue";
import { AxiosResponse } from "node_modules/axios";
import { Component, Vue } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { namespace } from "vuex-class";
import { AddUBOPayload, UBO } from "../types";
import PreviousPageArrow from "@/components/PreviousPageArrow.vue";

const Company = namespace("company");

@Component({
  metaInfo() {
    return {
      title: "Orba One | UBO Information",
    };
  },
  components: {
    "circular-loader": CircularLoader,
    "previous-page-arrow": PreviousPageArrow,
  },
  mixins: [validationMixin],
})
export default class UBOScreen extends Vue {
  @Company.Action("createUBOs") createUBOs!: (
    payload: AddUBOPayload
  ) => Promise<AxiosResponse>;
  @Company.Action("removeUBO") removeUBO!: (index: number) => void;
  @Company.Action("addToUBOList") addToUBOList!: (ubo: UBO) => void;
  @Company.Getter("getUBOs") ubos!: Array<UBO>;

  loading = false;
  checkedTypes = [] as any;
  uboForm = {
    firstName: "",
    uboType: "",
    lastName: "",
    mobileNumber: null,
    email: "",
  };

  formatMobileNumberField() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    // Formats the mobileNumber value using the following pattern: (XXX) XXX-XXXX
    const formattedTelephoneNumber = this.uboForm.mobileNumber
      .replace(/\D/g, "")
      .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    // Dynamically formats the value stored depending
    // on how many characters have been entered
    this.uboForm.mobileNumber = !formattedTelephoneNumber[2]
      ? formattedTelephoneNumber[1]
      : "(" +
        formattedTelephoneNumber[1] +
        ") " +
        formattedTelephoneNumber[2] +
        (formattedTelephoneNumber[3] ? "-" + formattedTelephoneNumber[3] : "");
  }

  add() {
    const ubo = {
      firstName: this.uboForm.firstName,
      lastName: this.uboForm.lastName,
      mobileNumber: this.uboForm.mobileNumber,
      email: this.uboForm.email,
      type: this.checkedTypes[0],
    };
    this.addToUBOList(ubo);
    this.clearForm();
  }

  submit() {
    this.loading = true;
    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    const companyId = params.get("companyId");
    if (publicKey && companyId) {
      this.createUBOs({
        publicKey: publicKey!,
        companyId: companyId!,
        data: this.ubos,
      }).then(() => {
        this.loading = false;
        this.$router.push({
          name: "finish-company",
        });
      });
    }
  }

  deleteUBO(index) {
    this.removeUBO(index);
  }

  setType(type: string) {
    this.uboForm.uboType = type;
    // ensures only the most recently selected checkbox will be active
    this.checkedTypes = [type];
  }

  clearForm() {
    this.uboForm = {
      firstName: "",
      uboType: "",
      lastName: "",
      mobileNumber: null,
      email: "",
    };
    this.checkedTypes = [];
    this.$v.$reset();
  }

  edit(ubo: UBO, index: number) {
    this.uboForm = {
      firstName: ubo.firstName,
      uboType: ubo.type,
      lastName: ubo.lastName,
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      mobileNumber: ubo.mobileNumber,
      email: ubo.email,
    };
    this.checkedTypes = [ubo.type];
    this.removeUBO(index);
  }

  validations() {
    return {
      uboForm: {
        firstName: {
          required,
        },
        lastName: {
          required,
        },
        mobileNumber: {
          required,
        },
        email: {
          required,
          email,
        },
      },
    };
  }
}
